/*
 * cluutch-charly-limites.js
 * Hôtel Charly : la limite d'achat dans le panier, demandée par la marque le 08/10/2026 :
 * les vanitys (SKU « CH- », type « Kit ») : 1 au plus en tout. La règle « 2 au plus par
 * référence » des autres produits Charly est retirée le 23/10/2026 (Hicham).
 * Même règle que snippets/cluutch-charly-max.liquid, qui grise le « + » du tiroir et de la
 * page panier. Ce script rattrape le reste : un ajout depuis une fiche, une quantité tapée,
 * deux vanitys différents.
 *
 * Choix structurants :
 * - tous les ajouts et changements de quantité du thème passent par window.fetch (relevé du
 *   08/10 : product.js, app.js, cart.js, cart-discounts.js, cluutch-pdp-2026.js). Le script
 *   enveloppe fetch pour /cart/add, /cart/change et /cart/update, et rien d'autre ;
 * - la correction se fait AVANT que le thème reçoive la réponse : le panier est ramené à la
 *   règle par /cart/change.js (avec le fetch d'origine, pour ne pas se rappeler soi-même), en
 *   demandant les mêmes sections ; le thème reçoit sa réponse avec les sections corrigées et
 *   le message déjà dedans. Un seul rendu, déjà juste ;
 * - les lignes de l'ajout en cours sont retirées en premier : le vanity déjà dans le panier
 *   reste, le second est refusé ;
 * - AUCUNE requête de lecture à l'ajout : le tiroir et la page panier qui reviennent dans la réponse
 *   d'ajout portent les lignes de vanity (data-charly-* posés par cart-drawer.liquid et main-cart.liquid) et
 *   suffisent à compter. /cart.js n'est lu qu'en repli, avec des reprises. Constaté le 08/10 : le défi
 *   anti-robot de la vitrine répond 429 à /cart.js quand on teste vite, et la règle sautait en silence ;
 * - sans vanity, la réponse passe telle quelle, sans requête de plus. Une erreur ici rend la
 *   réponse d'origine : le panier ne casse jamais à cause de ce script.
 * Limite assumée (Hicham, 08/10) : rien n'est contrôlé entre deux commandes, et un lien de
 * panier ou une requête forcée passent outre le site.
 * Chargé avant app.js par layout/theme.liquid, qui lui passe le message traduit.
 * Auteur : Cluutch / Studio Hogo.
 */
(function () {
	if (window.cluutchCharlyLimitesReady) return;
	window.cluutchCharlyLimitesReady = true;

	var script = document.currentScript;
	var MESSAGE_VANITY = script ? script.dataset.limiteVanity : '';
	var fetchOrigine = window.fetch;
	var CIBLE = /\/cart\/(add|change|update)(?:\.js)?\/?(?:[?#]|$)/;
	// Où le message entre dans les fragments que le thème remplace : en tête de la liste du
	// tiroir, sous le titre de la page panier.
	var HOTES = {
		'cart-drawer': { selecteur: '.product-cart-item--container', place: 'prepend' },
		'main-cart': { selecteur: '.thb-cart-form h4', place: 'after' }
	};
	var STYLE = 'margin: 0 0 12px; padding: 12px 14px; font-size: 14px; font-weight: 500; line-height: 1.4; color: #1a1a1a; background: #f4f4f4; border-left: 3px solid #4e1e25; border-radius: 0 4px 4px 0;';

	function route(nom, defaut) {
		return (window.theme && window.theme.routes && window.theme.routes[nom]) || defaut;
	}

	function estCharly(ligne) {
		return typeof ligne.sku === 'string' && ligne.sku.indexOf('CH-') === 0;
	}

	function estVanity(ligne) {
		return estCharly(ligne) && ligne.product_type === 'Kit';
	}

	// Ramène le total des lignes au plafond, en retirant dans l'ordre donné. Vrai s'il dépassait.
	function plafonner(lignes, plafond, vise) {
		var exces = lignes.reduce(function (somme, l) { return somme + vise[l.key]; }, 0) - plafond;
		if (exces <= 0) return false;
		lignes.forEach(function (l) {
			var retrait = Math.min(vise[l.key], exces);
			vise[l.key] -= retrait;
			exces -= retrait;
		});
		return true;
	}

	// Les quantités à écrire ({ clé de ligne: quantité }) et les messages, pour un panier donné.
	function corrections(items, recentes) {
		var ordre = items.filter(function (l) { return recentes.indexOf(l.key) >= 0; })
			.concat(items.filter(function (l) { return recentes.indexOf(l.key) < 0; }));
		var vise = {};
		items.forEach(function (l) { vise[l.key] = l.quantity; });

		var messages = plafonner(ordre.filter(estVanity), 1, vise) ? [MESSAGE_VANITY] : [];

		var cles = {};
		items.forEach(function (l) {
			if (vise[l.key] !== l.quantity) cles[l.key] = vise[l.key];
		});
		return { cles: cles, messages: messages.filter(Boolean) };
	}

	function lireJson(reponse) {
		if (!reponse.ok) throw new Error('cluutch-charly-limites : ' + reponse.status + ' ' + reponse.url);
		return reponse.json();
	}

	// Écrit les corrections une ligne après l'autre ; la dernière rapporte les sections.
	function corriger(cles, sections) {
		var liste = Object.keys(cles);
		return liste.reduce(function (suite, cle, i) {
			return suite.then(function () {
				var corps = { id: cle, quantity: cles[cle] };
				if (i === liste.length - 1 && sections.length) {
					corps.sections = sections.join(',');
					corps.sections_url = window.location.pathname;
				}
				return avecReprises(function () {
					return fetchOrigine.call(window, route('cart_change_url', '/cart/change') + '.js', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
						body: JSON.stringify(corps)
					}).then(lireJson);
				}, [1000]);
			});
		}, Promise.resolve());
	}

	// Glisse le message dans le HTML des sections du tiroir et de la page panier.
	function baliser(sections, messages) {
		if (!messages.length) return sections;
		Object.keys(HOTES).forEach(function (id) {
			if (!sections[id]) return;
			var doc = new DOMParser().parseFromString(sections[id], 'text/html');
			var hote = doc.querySelector(HOTES[id].selecteur);
			if (!hote) return;
			var message = doc.createElement('p');
			message.className = 'cluutch-charly-limite';
			message.setAttribute('role', 'alert');
			message.setAttribute('style', STYLE);
			message.textContent = messages.join(' · ');
			hote[HOTES[id].place](message);
			sections[id] = doc.body.innerHTML;
		});
		return sections;
	}

	// Une requête avec reprises espacées (429 du défi anti-robot, réseau) : les erreurs ne sautent pas la règle.
	function avecReprises(faire, delais) {
		return faire().catch(function (e) {
			if (!delais.length) throw e;
			return new Promise(function (ok) { setTimeout(ok, delais[0]); })
				.then(function () { return avecReprises(faire, delais.slice(1)); });
		});
	}

	function lirePanier() {
		return avecReprises(function () {
			return fetchOrigine.call(window, route('cart_url', '/cart') + '.js', {
				cache: 'no-store',
				headers: { Accept: 'application/json' }
			}).then(lireJson);
		}, [700, 1600]);
	}

	// Les lignes de vanity du tiroir (ou de la page panier) rendu dans la réponse d'ajout, sans requête de plus.
	function lignesDesSections(sections) {
		var html = sections && (sections['cart-drawer'] || sections['main-cart']);
		if (!html) return null;
		var doc = new DOMParser().parseFromString(html, 'text/html');
		var vues = {};
		var lignes = [];
		doc.querySelectorAll('quantity-selector[data-charly-sku]').forEach(function (q) {
			var cle = q.getAttribute('data-id');
			var champ = q.querySelector('input.qty');
			if (!cle || !champ || vues[cle]) return;
			vues[cle] = true;
			lignes.push({
				key: cle,
				variant_id: Number(q.getAttribute('data-charly-variant')),
				quantity: parseInt(champ.value, 10),
				sku: q.getAttribute('data-charly-sku'),
				product_type: q.getAttribute('data-charly-type')
			});
		});
		return lignes;
	}

	// La réponse corrigée, ou null si le panier respecte la règle.
	function verifier(type, donnees) {
		var sections = donnees.sections ? Object.keys(donnees.sections) : [];
		var recentes = [];
		var panier;
		if (type === 'add') {
			var ajoutees = (donnees.items || [donnees]).filter(estVanity);
			if (!ajoutees.length) return null;
			recentes = ajoutees.map(function (l) { return l.key; });
			var lues = lignesDesSections(donnees.sections);
			// Les sections ne valent que si elles contiennent les lignes qu'on vient d'ajouter.
			var completes = lues && recentes.every(function (k) { return lues.some(function (l) { return l.key === k; }); });
			panier = completes ? Promise.resolve({ items: lues }) : lirePanier();
		} else {
			if (!donnees.items || !donnees.items.some(estVanity)) return null;
			panier = Promise.resolve(donnees);
		}
		return panier.then(function (p) {
			var c = corrections(p.items, recentes);
			if (!Object.keys(c.cles).length) return null;
			return corriger(c.cles, sections).then(function (corrige) {
				var retour = type === 'add' ? donnees : corrige;
				if (sections.length) retour.sections = baliser(corrige.sections || {}, c.messages);
				return new Response(JSON.stringify(retour), {
					status: 200,
					headers: { 'Content-Type': 'application/json' }
				});
			});
		});
	}

	window.fetch = function (ressource, init) {
		var appel = fetchOrigine.apply(window, arguments);
		var url = String((ressource && ressource.url) || ressource || '');
		var methode = String((init && init.method) || (ressource && ressource.method) || 'GET').toUpperCase();
		var cible = CIBLE.exec(url);
		if (!cible || methode !== 'POST') return appel;
		return appel.then(function (reponse) {
			if (!reponse.ok) return reponse;
			return reponse.clone().json()
				.then(function (donnees) { return verifier(cible[1], donnees); })
				.then(function (corrigee) { return corrigee || reponse; })
				.catch(function (e) {
					console.error('cluutch-charly-limites', e);
					return reponse;
				});
		});
	};
})();
